// extracted by mini-css-extract-plugin
export default {"spinnerLayer":"tPf_5H"};